import { DocumentType } from '../../../enums/document-type';
import { uomBarcode } from '../document-type-epic-helpers/uom-barcode';
import * as Api from '../print.api';
import { jobRunner } from './job-runner';

/**
 * @param {Array<{ name: string, barcodeContent: string }>} barcodes
 * @param {object} [printer]
 * @param {number} [pusherTimeoutMs]
 * @returns {import('rxjs').Observable<import('./print-job-factory').PrintJob>}
 */
export const createUomBarcodeAsync = ({ barcodes, printer, pusherTimeoutMs }) => {
  const documentCount = barcodes.length;
  return jobRunner({
    apiRequest: () => Api.generateUomBarcodesAsync(barcodes),
    documentCount,
    documentTypeIdentifier: DocumentType.UomBarcode.identifier,
    initialNotification: uomBarcode.getAsyncPrintStartedNotificationProps(documentCount),
    errorNotification: uomBarcode.getAsyncPrintFailedNotificationProps(documentCount),
    ids: [],
    printer,
    pusherTimeoutMs,
  });
};
